export default "__VITE_ASSET__fdefadcc__"